import script from "./JaNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./JaNotice.vue?vue&type=script&setup=true&lang=js"

import "./JaNotice.vue?vue&type=style&index=0&id=a260d932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a260d932"]])

export default __exports__